import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useLoginApi } from '../api/use-login-user';
import { handleFormErrors } from '../../form/form-errors';
const loginSchema = z.object({
    email: z.string().min(1, 'too short').email('Invalid email'),
    password: z.string().min(5, 'too short'),
    longExpire: z.boolean(),
});
export const useLoginForm = ({ onSuccess }) => {
    const form = useForm({
        resolver: zodResolver(loginSchema),
        defaultValues: {
            email: '',
            password: '',
            longExpire: true,
        },
    });
    const login = useLoginApi({
        onSuccess,
        onError: (errors) => {
            handleFormErrors(form, errors);
        },
    });
    const onSubmit = form.handleSubmit((values) => {
        login.mutate(values);
    });
    return {
        form,
        isSubmitting: login.isPending,
        onSubmit,
    };
};
